export default function Spinner() {
    return (
        <div className="flex items-center justify-center min-h-[150px] w-full">
            <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-gray-500" />
        </div>
    );
}
